import { createTheme } from '@mui/material/styles';
import { blue } from './colors/colors';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#354EEF',
      light: '#7CAAD8',
      dark: '#3b89f7',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#697399',
      contrastText: '#ffffff',
    },
    background: {
      paper: '#1E1F25',
      default: '#111217',
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 900,
      lg: 1200,
      xl: 1600,
    },
  },

  typography: {
    fontFamily: "'BDO Grotesk', sans-serif",
    allVariants: {
      letterSpacing: '-0.02em',
    },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
        elevation0: {
          backgroundColor: '#1A1F2D',
        },
        elevation1: {
          background: '#131722',
          boxShadow: 'none',
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          padding: '16px clamp(16px, 2vw, 32px)',
          backgroundColor: '#111217',
          zIndex: 0,
          border: '1px solid #FFFFFF1A',
          boxShadow: 'none',
          borderRadius: '14px',
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E1F25',
          borderRadius: '16px',
          borderColor: '#FFFFFF1A',
          color: '#FFFFFF',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#354EEF',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#354EEF',
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: "'BDO Grotesk', sans-serif",
          letterSpacing: '-0.02em',
          transition: 'transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
          '&:active': {
            transform: 'translateY(0px) scale(0.98)',
          },
          '&.MuiButton-containedSecondary:hover': {
            backgroundColor: '#5969A4',
          },
        },
        contained: {
          backgroundColor: '#354EEF',
          border: '1px solid #FFFFFF1A',
          borderRadius: '8px',
          color: '#FFFFFF',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#275BE6',
            boxShadow: 'none',
            transform: 'translateY(-1px)',
          },
        },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: blue[400],
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: blue[400],
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: blue[400],
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E1F25',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #4A4A4A',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #4A4A4A',
        },
      },
    },
  },
});
